if (!window.SwymCallbacks) window.SwymCallbacks = [];

window.SwymCallbacks.push(initSwymUI);

let swat;
let settings;
let sectionId;
let elements;
let selectedList;
let wishlistedProducts;
let iconError;
let iconSpinner;
let iconHeart;
let tax;
let currency;

function initSwymUI(swatInstance) {
  swat = swatInstance;

  const wishlistElement = document.querySelector(".swymcs-wishlist");

  settings = JSON.parse(wishlistElement.dataset.settings);
  sectionId = wishlistElement.dataset.id;
  iconError = wishlistElement.dataset.iconError;
  iconSpinner = wishlistElement.dataset.iconSpinner;
  iconHeart = wishlistElement.dataset.iconHeart;
  tax = wishlistElement.dataset.tax;
  currency = wishlistElement.dataset.currency;

  elements = {
    loader: wishlistElement.querySelector(".js-wishlist-loader"),
    container: wishlistElement.querySelector(".js-wishlist-container"),
    listOptions: wishlistElement.querySelector(".js-wishlist-dropdown"),
    itemsContainer: wishlistElement.querySelector(".js-wishlist-grid"),
    emptyDescription: wishlistElement.querySelector(".js-wishlist-description"),
    content: wishlistElement.querySelector(".js-wishlist-content"),
    count: wishlistElement.querySelector(".js-wishlist-count"),
    addToBag: wishlistElement.querySelector(".js-wishlist-add"),
    copyButton: wishlistElement.querySelector(".js-wishlist-copy"),
    collections: document.querySelector(".section--featured-content"),
    spinner: wishlistElement.querySelector(".js-wishlist-spinner"),
    cart: document.querySelector("cart-drawer"),
  };

  elements.collections?.classList.add("hidden");

  fetchWishlist();

  addAllToBagListener();
  addCopyToClipboardListener();

  subscribe(PUB_SUB_EVENTS.wishlistShareSubmit, (form) =>
    shareWishlistByEmail(form)
  );
}

function addCopyToClipboardListener() {
  if (elements.copyButton) {
    elements.copyButton.addEventListener("click", () => {
      const lid = swat.swymCustomWishlistSelectedListId;

      const onSuccess = (link) => {
        navigator.clipboard
          .writeText(link)
          .then(() =>
            showFormNotification(window.wishlistStrings.form.copy.success)
          )
          .catch(() =>
            showFormNotification(window.wishlistStrings.form.copy.error)
          );
      };

      const onError = () =>
        showFormNotification(window.wishlistStrings.form.copy.error);

      swat.generateSharedListURL(lid, onSuccess, onError);
    });
  }
}

function shareWishlistByEmail(form) {
  const params = {
    toEmailId: form?.email,
    fromName: form?.name,
    note: form?.comment || "Hey, check out these products!",
    lid: swat.swymCustomWishlistSelectedListId,
  };

  const onSuccess = () =>
    showFormNotification(window.wishlistStrings.form.email.success);
  const onError = () =>
    showFormNotification(window.wishlistStrings.form.email.error);

  swat.sendListViaEmail(params, onSuccess, onError);
}

const showFormNotification = (text) => {
  const successMessage = `
      <div class="swym-custom-notification-content">
        <div class="swym-custom-title-container">
          ${text}
        </div>
      </div>
    `;

  swat.ui.showSuccessNotification({ message: successMessage });
};

function addAllToBagListener() {
  elements.addToBag.addEventListener("click", async () => {
    const products = document.querySelectorAll(".swymcs-wishlist-card");
    const items = [];

    products.forEach((product) => {
      const id = product.dataset.epi;
      const quantity = product.dataset.quantity || 1;
      const barcode = product.dataset.barcode;
      const groupType = product.dataset?.customGroupType;
      const groupValue = product.dataset?.customGroupValue;

      items.push({
        id,
        quantity,
        properties: {
          ...(barcode != null && { _barcode: barcode }),
          ...(groupType && groupValue && { [groupType]: groupValue }),
        },
      });
    });

    addToBag(items);
  });
}

function addToBag(products) {
  let formData = {
    items: [...products],
    sections: ["cart-drawer", "cart-icon-bubble"],
    sections_url: window.location.pathname,
  };

  elements.addToBag.classList.add("loading");
  elements.spinner.classList.remove("hidden");

  fetch(`${routes.cart_add_url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/javascript",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) throw new Error(response.description || response.message);

      elements.cart.renderContents(response);
    })
    .catch((error) => console.error("Error:", error))
    .finally(() => {
      if (elements.cart && elements.cart.classList.contains("is-empty"))
        elements.cart.classList.remove("is-empty");

      elements.addToBag.classList.remove("loading");
      elements.spinner.classList.add("hidden");
    });
}

function fetchWishlist() {
  showLoader();

  swat.fetchLists({
    callbackFn: (lists) => {
      lists = lists.reverse();

      swat.swymCustomWishlistLists = lists;

      const currentListId =
        swat.swymCustomWishlistSelectedListId || lists[0]?.lid;

      swat.swymCustomWishlistSelectedListId = currentListId;

      selectedList = lists.find(({ lid }) => lid === currentListId) || lists[0];

      // if (swat.isCollectionsEnabled()) renderMultipleListOptions(lists);

      renderList(selectedList.listcontents);
    },
    errorFn: (error) => console.error("Error while fetching all Lists", error),
  });
}

async function renderList(list) {
  const hasItems = list.length > 0;

  elements.itemsContainer.innerHTML = "";

  if (hasItems) {
    wishlistedProducts = await fetchProductData(list);
    wishlistedProducts.forEach(renderWishlistItem);

    addCount(wishlistedProducts.length);
  }

  updateUIState(hasItems);
}

const addCount = (count) =>
  (elements.count.textContent = window.wishlistStrings.count.replace(
    "{{ count }}",
    count
  ));

async function fetchProductData(wishlist) {
  const productDataPromises = wishlist.map(async (listItem) => {
    const response = await fetch(`${listItem.du.split("?")[0]}.js`);
    const groupDataResponse = await fetch(
      `${listItem.du.split("?")[0]}?view=groupdata`
    );

    listItem.productData = await response.json();
    listItem.productData.groupData = await groupDataResponse.json();

    return listItem;
  });

  return await Promise.all(productDataPromises);
}

function renderMultipleListOptions(lists) {
  if (lists.length > 1) {
    const listOptionsHtml = lists
      .map(
        ({ id, name, listContents }) => `
      <option class="swymcs-wishlist-list-option" value="${id}" ${
          id === swat.swymCustomWishlistSelectedListId ? "selected" : ""
        }>
        ${name} (${listContents.length} items)
      </option>`
      )
      .join("");

    elements.listOptions.innerHTML = `
      <select
        class="swymcs-wishlist-list"
        id="swym-mutliple-list"
        onchange="onListChange(event)">
        ${listOptionsHtml}
      </select>
  `;
  }
}

function onListChange(event) {
  swat.swymCustomWishlistSelectedListId = event.target.value;

  const selectedList = swat.swymCustomWishlistLists.find(
    ({ lid }) => lid === event.target.value
  );

  renderList(selectedList.listcontents);
}

function renderWishlistItem(item) {
  const wishlistItem = document.createElement("div");

  wishlistItem.classList.add("swymcs-wishlist-card");
  wishlistItem.dataset.epi = item.epi;
  wishlistItem.dataset.empi = item.empi;
  wishlistItem.dataset.du = item.du;
  wishlistItem.dataset.sectionid = sectionId;

  const productImage = item.productData?.featured_image || item.iu;
  const selectedVariant = item.productData.variants.find(
    (variant) => variant.id === item.epi
  );
  const price = selectedVariant?.price || item.productData.price;
  const currencyFormat =
    window.storeName === "UK" ? `${currency}{{amount}}` : `{{amount}} AED`;
  const formattedPrice = Shopify.formatMoney(price, currencyFormat);
  const taxRate = tax > 0 ? tax / 100 + 1 : 0;
  const formattedTaxRate =
    taxRate > 0
      ? Shopify.formatMoney(Math.round(price / taxRate), currencyFormat)
      : "";
  const priceWithTax = formattedTaxRate
    ? window.taxString.excludingTaxParenthesesPrice.replace(
        "{{ price }}",
        formattedTaxRate
      )
    : "";

  if (item.productData?.groupData?.type) {
    wishlistItem.dataset.customGroupType = item.productData.groupData.type;
  }
  if (item.productData?.groupData?.value) {
    wishlistItem.dataset.customGroupValue = item.productData.groupData.value;
  }
  wishlistItem.dataset.barcode = selectedVariant?.barcode || "";
  wishlistItem.innerHTML = renderWishlistCard(
    item,
    productImage,
    selectedVariant,
    formattedPrice,
    priceWithTax
  );

  addRemoveListener(item, wishlistItem);
  addToBagListener(wishlistItem);

  elements.itemsContainer.appendChild(wishlistItem);
}

function addToBagListener(card) {
  const addToBagButton = card.querySelector(".product-form__submit");

  addToBagButton?.addEventListener("click", (e) => {
    e.preventDefault();
    const id = card.dataset.epi;
    const quantity = card.dataset.quantity || 1;
    const barcode = card.dataset.barcode;
    const groupType = card.dataset?.customGroupType;
    const groupValue = card.dataset?.customGroupValue;

    addToBag([
      {
        id,
        quantity,
        properties: {
          ...(barcode != null && { _barcode: barcode }),
          ...(groupType && groupValue && { [groupType]: groupValue }),
        },
      },
    ]);
  });
}

function addRemoveListener(product, card) {
  const removeFromWishlistButton = card.querySelector(".js-remove-product");

  removeFromWishlistButton?.addEventListener("click", () =>
    removeProductFromWishlist(product)
  );
}

function removeProductFromWishlist(product) {
  const item = { epi: product.epi, empi: product.empi, du: product.du };

  swat.deleteFromList(
    swat.swymCustomWishlistSelectedListId,
    item,
    () => fetchWishlist(),
    (error) => console.error("Failed to remove from wishlist", error)
  );
}

function updateUIState(hasWishlist) {
  hideLoader();

  elements.container.classList[hasWishlist ? "remove" : "add"](
    "swymcs-wishlist__container--hidden"
  );
  elements.content.classList[hasWishlist ? "remove" : "add"](
    "swymcs-wishlist__content--hidden"
  );
  elements.emptyDescription.classList[hasWishlist ? "add" : "remove"](
    "swymcs-wishlist__description--hidden"
  );
  elements.collections?.classList[[hasWishlist ? "add" : "remove"]]("hidden");
}

const showLoader = () =>
  elements.loader.classList.remove("swymcs-wishlist__loader--hidden");
const hideLoader = () =>
  elements.loader.classList.add("swymcs-wishlist__loader--hidden");

const renderWishlistCard = (
  item,
  image,
  selectedVariant,
  price,
  priceWithTax
) => `
  <a
    href="${item.du}"
    class="swymcs-wishlist-card__figure">
      <img
        src="${image}"
        alt="${item.dt}"
        class="swymcs-wishlist-card__image"/>
  </a>
  <button
    aria-label="${window.wishlistStrings.remove}"
    class="swymcs-wishlist-card__remove js-remove-product">
    ${iconHeart}
  </button>
  <div class="swymcs-wishlist-card__content">
    <div class="swymcs-wishlist-card__header">
      <div class="swymcs-wishlist-card__name">
        <a
          href="${item.du}"
          class="swymcs-wishlist-card__title">
          ${item.dt}
        </a>
      </div>
      <div class="swymcs-wishlist-card__total">
        <div class="swymcs-wishlist-card__price">
          ${price}
        </div>
        <div class="swymcs-wishlist-card__vat">
          ${priceWithTax}
        </div>
      </div>
    </div>
    <div class="swymcs-wishlist-card__footer">
      <product-form class="product-form" data-hide-errors="false">
        <div class="product-form__error-message-wrapper" role="alert" hidden="">
          ${iconError}
          <span class="product-form__error-message"></span>
        </div>
        <form
          method="post"
          action="/cart/add"
          id="product-form-template--18712650875130__main"
          accept-charset="UTF-8"
          class="form"
          enctype="multipart/form-data"
          novalidate="novalidate"
          data-type="add-to-cart-form">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="id" value="${
            selectedVariant.id
          }" class="product-variant-id">
            <button
              id="ProductSubmitButton-template--18712650875130__main"
              type="submit"
              name="add"
              class="product-form__submit button button--full-width"
              ${!selectedVariant?.available ? "disabled" : ""}
              aria-haspopup="dialog">
              <span>${getButtonState(selectedVariant)}</span>
              <div class="loading-overlay__spinner hidden">
                ${iconSpinner}
              </div>
            </button>
          </div>
          <input type="hidden" name="product-id" value="${item.productData.id}">
          <input type="hidden" name="section-id" value="template--18712650875130__main">
        </form>
      </product-form>
    </div>
  </div>
`;

const getButtonState = (variant) => {
  const isInCart = _swat.platform.isInDeviceCart(variant.id);

  return variant?.available
    ? isInCart
      ? window.wishlistStrings.addedToCart
      : window.variantStrings.addToCart
    : window.variantStrings.soldOut;
};
